"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserFontSizeFactor = void 0;
var useBrowserFontSizeFactor_1 = require("./tools/useBrowserFontSizeFactor");
var ViewPortAdapter_1 = require("./ViewPortAdapter");
function useBrowserFontSizeFactor() {
    var viewPortState = (0, ViewPortAdapter_1.useViewPortState)().viewPortState;
    var browserFontSizeFactor = (0, useBrowserFontSizeFactor_1.useBrowserFontSizeFactor)().browserFontSizeFactor;
    return {
        "browserFontSizeFactor": viewPortState !== undefined ?
            viewPortState.targetBrowserFontSizeFactor :
            browserFontSizeFactor
    };
}
exports.useBrowserFontSizeFactor = useBrowserFontSizeFactor;
//# sourceMappingURL=useBrowserFontSizeFactor.js.map